module.exports = __webpack_public_path__ + "static/media/Layout--5.a8d29a62.jpg";